import React from "react"

import {
    Box,
    Button,
    Dialog,
    Typography,
} from "@mui/material"

import { Trans } from "@lingui/macro"

import {
    Template,
    Workflow,
} from "models"

interface DeleteWorkflowProp
{
    openDialog: boolean
    onClose: () => void
    delete: (id: string) => void
    data: Workflow | Template
}

interface DeleteWorkflowState
{

}

export class DeleteWorkflow extends React.Component<DeleteWorkflowProp, DeleteWorkflowState>
{
    render()
    {
        return (
            <Dialog open={this.props.openDialog} onClose={this.props.onClose} fullWidth>
                <Typography variant="h5" sx={{ml: 2, mt: 2}}>
                    <Trans id={'workflow.delete-workflow.title'}>
                        Attenzione
                    </Trans>
                </Typography>
                <Typography sx={{ml: 2, mt: 2}}>
                    <Trans>
                        L'operazione è irreversibile e verranno eliminate anche le azioni non ancora eseguite collegate al Workflow selezionato.
                    </Trans>
                </Typography>
                <Typography sx={{ml: 2, mt: 4}}>
                    <Trans>
                        Sicuro di voler eliminare il workflow "{this.props.data.name}"?
                    </Trans>
                </Typography>
                <Box sx={{my: 2, mr: 2}} textAlign={"right"}>
                    <Button size="small"
                            onClick={this.props.onClose}
                            variant={"contained"}
                            color="neutral"
                            sx={{
                                textTransform: "none",
                                mr: 3,
                            }}
                            disableElevation
                    >
                        <Trans id="workflow.delete-workflow.abort">
                            Annulla
                        </Trans>
                    </Button>
                    <Button variant={"contained"}
                            disableElevation
                            sx={{
                                textTransform: "none",
                                color: "background.default",
                                bgcolor: "error.main"
                            }}
                            onClick={() => this.props.delete(this.props.data.id)}
                    >
                        <Trans id="workflow.delete-workflow.delete">
                            Elimina
                        </Trans>
                    </Button>
                </Box>
            </Dialog>
        )
    }
}
